import React from "react";
import { Route, Routes } from "react-router-dom";
import Home from "../pages/Home/index.js";
import AiAgriculture from "../pages/AI/index.js";
import Achievements from "../pages/Achievements/index.js";
import Music from "../pages/Music/index.js";
import DoubleCanons from "../pages/DoubleCanons/index.js";
import StrivingForChange from "../pages/Striving/index.js";


const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/ai" element={<AiAgriculture />} />
      <Route path="/achievements" element={<Achievements />} />
      <Route path="/music" element={<Music />} />
      <Route path="/double" element={<DoubleCanons />} />
      <Route path="/striving" element={<StrivingForChange />} />
    </Routes>
  );
};

export default AppRoutes;
